import React, { FC, useEffect } from 'react';
import { IconAccordion } from '@components/molecules/IconAccordion';
import { useData } from '@hooks/useData';
import { RadioButtonType } from '@components/atoms/RadioButton';
import { useGetAllLockers } from '@services/useGetAllLockers';
import { AddressOption } from '@components/molecules/AddressOption';
import { Loader } from '@components/molecules/Pagination';
import { ErrorMessages } from '@components/atoms/ErrorMessages';

interface AtLockerPickupProps {
    selectedLocker: string | null;
    handleOnSelectLocker: (value: string | null) => void;
}

const AtLocker: FC<AtLockerPickupProps> = ({ selectedLocker, handleOnSelectLocker }) => {
    const { cart, allLockers } = useData();
    const { request: requestGetAllLockers, loading, error } = useGetAllLockers();

    useEffect(() => {
        requestGetAllLockers();
    }, []);

    // initially check locker, if cart was already assigned a locker for delivery
    useEffect(() => {
        if (cart?.data?.delivery?.pickupAtLocker !== null && cart?.data?.delivery?.pickupAtLocker) {
            handleOnSelectLocker(cart?.data?.delivery?.pickupAtLocker);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart?.data?.delivery?.pickupAtLocker]);

    return (
        <IconAccordion.IndentedContent>
            <div className="row pe-2 g-4">
                {loading ? (
                    <Loader />
                ) : error ? (
                    <ErrorMessages messages={[error]} />
                ) : (
                    <>
                        {allLockers?.data?.map((locker, index) => (
                            <div key={`locker-${index}`} className="col-12 col-xl-6">
                                <AddressOption
                                    radioButton={{
                                        id: `locker-${index}`,
                                        name: 'locker',
                                        value: `${locker.id}`,
                                        type: RadioButtonType.normal,
                                        checked: selectedLocker === `${locker.id}`,
                                        onChange: handleOnSelectLocker,
                                    }}
                                    name={locker.name || ''}
                                    lastName=""
                                    fiscalNumber=""
                                    address={locker.address || ''}
                                    postalCode={locker.postalCode || ''}
                                    note={locker.location}
                                />
                            </div>
                        ))}
                    </>
                )}
            </div>
        </IconAccordion.IndentedContent>
    );
};

export default AtLocker;
